export const timeoutMessages = {
    GET_BROWSER_TIMEOUT_MSG: 'get-browser-timeout',
    TEST_START_TIMEOUT_MSG: 'test-start-timeout',
    TEST_COMPLETE_TIMEOUT_MSG: 'test-complete-timeout',
    TEST_REACHED_CUSTOM_TIMEOUT_MSG: 'test-reached-custom-timeout',
} as const;
export const testRunStatus = {
    COMPLETED: 'completed',
} as const;

export const runnerStatus = {
    RUNNING: 'RUNNING',
    SKIPPED: 'SKIPPED',
    FINISHED: 'FINISHED',
    ABORTED: 'ABORTED',
    QUEUED: 'QUEUED',
    TIMEOUT: 'TIMEOUT',
} as const;

export const runnerTestStatus = {
    PASSED: 'PASSED',
    FAILED: 'FAILED',
    ABORTED: 'ABORTED',
    SKIPPED: 'SKIPPED',
    QUEUED: 'QUEUED',
    PENDING: 'PENDING',
} as const;

export const testStatus = {
    DRAFT: 'draft',
    EVALUATING: 'evaluating',
    ACTIVE: 'active',
    QUARANTINE: 'quarantine',
} as const;
export const gridMessages = {
    NOT_FOUND: 'The specified grid is not available',
    UNKNOWN: "Test couldn't get browser - unknown error",
} as const;

export const mobileWeb = {
    MOBILE_WEB_REMOTE_RUN_HEADER_SPACING: 50,
} as const;

export const test = {
    HIDDEN_PARAM: 'TST_HIDDEN_PARAM',
} as const;

export const socketEventTypes = {
    TEST_RESULT_CREATED: 'test-result-created',
    TEST_RESULT_UPDATED: 'test-result-updated',
    REMOTE_STEP_SAVED: 'remote-step-saved',
} as const;

export const CLI_MODE = {
    EXTENSION: 'extension',
    SELENIUM: 'selenium',
    APPIUM: 'appium',
} as const;

export const gridTypes = {
    LOCAL: 'local',
    TESTIM_ENTERPRISE: 'testimEnterprise',
    TESTIM: 'testim',
    TESTIM_PRIVATE: 'testimPrivate',
    LAMBDATEST: 'lambdaTest',
    TESTIM_LAMBDATEST: 'testimLambdaTest',
    DEVICE_FARM: 'testimDF',
    HYBRID: 'testimHybrid',
    BROWSERSTACK: 'browserstack',
    SAUCELABS: 'saucelabs',
    TESTIM_TDC: 'testimTDC',
    TESTIM_TVC: 'testimTVC',
} as const;

export type GridType = (typeof gridTypes)[keyof typeof gridTypes];

export const stepResult = {
    SETUP_TIMEOUT: 'setup-timeout',
    NETWORK_ERROR: 'network-error',
    GRID_ERROR: 'grid-error',
    SELENIUM_ERROR: 'selenium-error',
    BROWSER_CLOSED: 'browser-closed',
    MOBILE_SESSION_ERROR: 'mobile-session-error',
    UNKNOWN_ERROR: 'unknown-error',
    KEEP_ALIVE_FAILED: 'keep-alive-failed',
} as const;

export const MOBILE_APP_SOURCE = {
    FROM_LIBRARY: 'from-library',
    FROM_DEVICE: 'from-device',
} as const;

export const MOBILE_RUN_SKIP_REASON = {
    APP_FROM_DEVICE: 'app-from-device',
    VIRTUAL_BUILD: 'virtual-build',
} as const;

export const APPIUM_SESSION_MESSAGE = {
    APP_NOT_EXIST_ON_DEVICE: "used to start the app doesn't exist or cannot be launched",
    APP_NEVER_STARTED: 'never started',
    DEVICE_OS_VERSION_TOO_LOW: 'DeviceOSVersionTooLow',
    TIMEOUT_ERROR: "Timeout awaiting 'request'",
    SAUCELABS_APP_IS_NOT_INSTALLED: "Original error: 'app' option is required for reinstall",
} as const;

export const X_HEADER_RUNNER_ID = 'X-Testim-Runner-ID';

export const REGION_CONFIG = {
    TTL: 1000 * 60 * 60 * 24, // 24 hours
    CACHE_FN_NAME: 'setRegionConfig',
} as const;

export const SEGMENT_CONFIG = {
    TTL: 1000 * 60 * 60 * 72, // 3 days
    CACHE_FN_NAME: 'setSegmentConfig',
} as const;

export enum OPERANDS {
    AND = 'AND',
    OR = 'OR',
}
